<div class="wp-table-timeline--header">
  <div class="wp-table-timeline--header-inner"></div>
</div>
